import { Component, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FeathersAppService } from '@fire/feathers/src/app';
import { AppConfig } from '../../config/app.config';
import { AppService } from '../../services/app.service';
import { fireLogger } from '../../utils/fire-logger';



@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {


  constructor(
    private router:Router,
    private feathers:FeathersAppService,
    private appService:AppService,
  ) {
  }


  ngOnInit() {

    this.appService.initializeApp()
      .then(() => fireLogger.log('App initialized'))
      .catch(err => fireLogger.error('Error initializing app (app.ts)', err));

    this.scrollToTopOnRouteChange();

  }







  scrollToTopOnRouteChange() {
    this.router.events.subscribe(event => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      document.body.scrollTop = 0;
    });
  }



}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/containers/app/app.ts